import {
  formatBoolean,
  formatDate,
  formatDateTime,
  formatNumber
} from './converters';

const getPath = (p, o) => {
  if (!p || typeof p !== 'string' || !o || typeof o !== 'object') {
    return null;
  }
  return p
    .split('.')
    .reduce((xs, x) => (xs && xs[x] !== undefined ? xs[x] : null), o);
};

const filterConditions = {
  EQUALS: 'equals',
  NOT_EQUALS: 'notEquals',
  NULL: 'null',
  NOT_NULL: 'notNull',
  LIKE: 'like',
  ILIKE: 'ilike',
  NOT_LIKE: 'notLike',
  GT: 'gt',
  GTE: 'gte',
  LT: 'lt',
  LTE: 'lte',
  IN: 'in',
  BETWEEN: 'between'
};

const fieldTypesCfg = Object.freeze({
  STRING: {
    filterConditions: [
      {
        condition: filterConditions.LIKE,
        label: 'Contiene'
      },
      {
        condition: filterConditions.EQUALS,
        label: 'Igual a'
      }
    ],
    render: (row, name) => getPath(name, row)
  },
  NUMERIC: {
    filterConditions: [
      {
        condition: filterConditions.EQUALS,
        label: 'Igual a'
      },
      {
        condition: filterConditions.LT,
        label: 'Menor que'
      },
      {
        condition: filterConditions.GT,
        label: 'Mayor que'
      }
    ],
    render: (row, name) => formatNumber(getPath(name, row))
  },
  DATE: {
    filterConditions: [
      {
        condition: filterConditions.EQUALS,
        label: 'Igual a'
      },
      {
        condition: filterConditions.LT,
        label: 'Antes de'
      },
      {
        condition: filterConditions.GT,
        label: 'Después de'
      }
    ],
    render: (row, name) => formatDate(getPath(name, row))
  },
  DATE_RANGE: {
    filterConditions: [
      {
        condition: filterConditions.BETWEEN,
        label: 'Entre'
      }
    ],
    render: (row, name) => formatDate(getPath(name, row))
  },
  DATETIME: {
    filterConditions: [
      {
        condition: filterConditions.LT,
        label: 'Antes de'
      },
      {
        condition: filterConditions.EQUALS,
        label: 'Igual a'
      },
      {
        condition: filterConditions.GT,
        label: 'Después de'
      }
    ],
    render: (row, name) => formatDateTime(getPath(name, row))
  },
  BOOLEAN: {
    filterConditions: [
      {
        condition: filterConditions.EQUALS,
        label: 'Igual a'
      }
    ],
    render: (row, name) => formatBoolean(getPath(name, row))
  },
  ENUM: {
    filterConditions: [
      {
        condition: filterConditions.IN,
        label: 'Incluye a'
      }
    ],
    render: (row, name, setting) => {
      if (setting) {
        if (setting.filterable && setting.filterable.getOptionLabel) {
          return setting.filterable.getOptionLabel(getPath(name, row));
        }
        if (setting.filterable && setting.filterable.options) {
          return setting.filterable.options[getPath(name, row)];
        }
      }
      return getPath(name, row);
    }
  },
  OBJECT: {
    filterConditions: [
      {
        condition: filterConditions.EQUALS,
        label: 'Igual a'
      }
    ],
    render: (row, name, setting) => {
      return setting && setting.filterable && setting.filterable.getOptionLabel
        ? setting.filterable.getOptionLabel(getPath(name, row))
        : '-';
    }
  }
});

const fieldTypes = Object.keys(fieldTypesCfg).reduce((types, type) => {
  // eslint-disable-next-line no-param-reassign
  types[type] = type;
  return types;
}, {});

const filterConditionsByType = Object.keys(fieldTypesCfg).reduce(
  (conditionsByType, type) => {
    // eslint-disable-next-line no-param-reassign
    conditionsByType[type] = fieldTypesCfg[type].filterConditions;
    return conditionsByType;
  },
  {}
);

const lowerCaseFirstLetter = (str) => {
  return str.charAt(0).toLowerCase() + str.slice(1);
};

/**
 * Gets the label for a given filter, as configured by field type and filter condition in fieldTypesCfg object, with
 * the first letter lowercased
 * @param filter filter wich label is wanted
 * @returns {*} filter label
 */
export const getFilterLabel = (filter) => {
  let label;
  if (filter && filter.type && filter.condition) {
    const fieldType = fieldTypesCfg[filter.type];
    if (fieldType) {
      const filterCondition = fieldType.filterConditions.find(
        (fc) => fc.condition === filter.condition
      );
      label =
        (filterCondition &&
          filterCondition.label &&
          lowerCaseFirstLetter(filterCondition.label)) ||
        'unknown-condition';
    } else {
      label = 'unknown-field-type';
    }
  }
  return label;
};

const GENERAL_FILTER_FIELD = '_GENERAL_FILTER_FIELD_';

export {
  filterConditions,
  fieldTypesCfg,
  fieldTypes,
  filterConditionsByType,
  GENERAL_FILTER_FIELD
};
